export const USER_LANGUAGE_FRENCH = "fr-FR";
export const USER_LANGUAGE_ENGLISH = "en-US";

/**
 * Map short or BCP-47 user language codes to the canonical values stored in API.
 */
export function canonicalUserLanguage(value) {
    if (value == null || value === "") {
        return null;
    }

    const primary = String(value).split(/[-_]/)[0].toLowerCase();
    if (primary === "fr") {
        return USER_LANGUAGE_FRENCH;
    }
    if (primary === "en") {
        return USER_LANGUAGE_ENGLISH;
    }
    return null;
}

export function userLanguagePrimary(value) {
    if (value == null || value === "") {
        return null;
    }
    return String(value).split(/[-_]/)[0].toLowerCase();
}

export function userLanguageLabel(value, availableLanguages = {}) {
    const primary = userLanguagePrimary(value);
    if (!primary) {
        return null;
    }
    return availableLanguages[primary] || null;
}

export function canonicalEntityLanguage(value) {
    return canonicalUserLanguage(value) || USER_LANGUAGE_FRENCH;
}

export function entityLanguageOptions(labelForKey) {
    return [
        {
            value: USER_LANGUAGE_FRENCH,
            text: labelForKey("french"),
        },
        {
            value: USER_LANGUAGE_ENGLISH,
            text: labelForKey("english"),
        },
    ];
}

export function userLanguageOptions(translate) {
    return [
        {
            value: null,
            text: translate("browserDefault"),
        },
        {
            value: USER_LANGUAGE_FRENCH,
            text: translate("french"),
        },
        {
            value: USER_LANGUAGE_ENGLISH,
            text: translate("english"),
        },
    ];
}
